module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABT0lEQVQ4T8XRsUoEMRAG4H9yqbTQUrDxHkBYmQ1op42FYCNyID6BJyja2AnaWIn6BDaC2IuFFmJlFW7thEO55noLRdDsjKxworB77IpgyuSfL5kJoXgZZj4FsADA9sm9ANimooBzzonIJYApEXktyhljJgCcFEJxHE+r6rH3vt7nNYiiaKxWqz2Wgph5vwB7SNP0ogp0lAcRUTuEcF4aKtuacc6xqg5+LxCRiIi2iGgpDwohdJMkaX/NiJnPAMwCeOp3c87ZiKo2ReT6szVmfgcw7r2/rwLFcbwhIjMistaDNE3TepIknSoQM6+o6ryINH9A1to9VZ0siR0CeMuFiGjIWjtcBgohdIwxc7nQn7X2rxCAVSK6UtXF7Pt//WsAdgDcGGMOMuiZiJZDCHdlBt3LWGvXVXXUe9/I9jJoE8AugIEqEICuiDRardZtVvcBzvXjFG8FTP0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/public/img/shop5.png
// module id = suHs
// module chunks = 13